import { FC, memo } from 'react'
import Box from '@mui/material/Box'
import { useCompanyCards } from '../../../providers/CompanyCardsProvider'
import CompanyCardRow from './CompanyCardRow'
import { Typography } from '@mui/material'

const CompanyCardsPanel: FC = () => {
  const { companyCards, status } = useCompanyCards()
  return (
    <Box
      sx={{
        marginBottom: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {status === 'empty' && (
        <Box sx={{ height: 56 }}>
          <Typography>No payment methods found</Typography>
        </Box>
      )}
      {companyCards.map(companyCard => {
        return <CompanyCardRow key={companyCard.id} companyCard={companyCard} />
      })}
    </Box>
  )
}

export default memo(CompanyCardsPanel)
